import { toString30pk9tzaqopn as toString } from './Library.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from './js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PairClass;
function Pair() {
  if (PairClass === VOID) {
    class $ {
      constructor(first, second) {
        this.ue_1 = first;
        this.ve_1 = second;
      }
      toString() {
        return '(' + toString(this.ue_1) + ', ' + toString(this.ve_1) + ')';
      }
      we() {
        return this.ue_1;
      }
      xe() {
        return this.ve_1;
      }
      lt(first, second) {
        return new (Pair())(first, second);
      }
      mt(first, second, $super) {
        first = first === VOID ? this.ue_1 : first;
        second = second === VOID ? this.ve_1 : second;
        return $super === VOID ? this.lt(first, second) : $super.lt.call(this, first, second);
      }
      hashCode() {
        var result = this.ue_1 == null ? 0 : hashCode(this.ue_1);
        result = imul(result, 31) + (this.ve_1 == null ? 0 : hashCode(this.ve_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Pair()))
          return false;
        if (!equals(this.ue_1, other.ue_1))
          return false;
        if (!equals(this.ve_1, other.ve_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Pair');
    PairClass = $;
  }
  return PairClass;
}
function to(_this__u8e3s4, that) {
  return new (Pair())(_this__u8e3s4, that);
}
var TripleClass;
function Triple() {
  if (TripleClass === VOID) {
    class $ {
      constructor(first, second, third) {
        this.nt_1 = first;
        this.ot_1 = second;
        this.pt_1 = third;
      }
      toString() {
        return '(' + toString(this.nt_1) + ', ' + toString(this.ot_1) + ', ' + toString(this.pt_1) + ')';
      }
      hashCode() {
        var result = this.nt_1 == null ? 0 : hashCode(this.nt_1);
        result = imul(result, 31) + (this.ot_1 == null ? 0 : hashCode(this.ot_1)) | 0;
        result = imul(result, 31) + (this.pt_1 == null ? 0 : hashCode(this.pt_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Triple()))
          return false;
        if (!equals(this.nt_1, other.nt_1))
          return false;
        if (!equals(this.ot_1, other.ot_1))
          return false;
        if (!equals(this.pt_1, other.pt_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Triple');
    TripleClass = $;
  }
  return TripleClass;
}
//region block: exports
export {
  Pair as Paire9pteg33gng7,
  Triple as Triple1vhi3d0dgpnjb,
  to as to2cs3ny02qtbcb,
};
//endregion

//# sourceMappingURL=Tuples.mjs.map
